import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useSearchParams, useNavigate } from "react-router-dom";
import { ImpersonateUser } from "../../redux/actions/auth";
import LoadingSpinner from "../../components/Common/LoadingSpinner";

const CheckImpersonate = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const hasTriggeredRef = useRef(false);

  const key = searchParams.get("key");
  const impersonator = searchParams.get("impersonator");
  const impersonated = searchParams.get("impersonated");

  const hasImpersonateParams = Boolean(impersonator && impersonated && key);

  useEffect(() => {
    if (!hasImpersonateParams || hasTriggeredRef.current) {
      return;
    }

    hasTriggeredRef.current = true;

    // Cache the credentials locally for the payload
    const payload = {
      key,
      impersonator,
      impersonated,
    };

    // 1. Immediately sanitize the browser address bar & history (Fix for C-AUTH-02)
    // Strips '?key=...&impersonator=...&impersonated=...' to prevent Referer leaks & history theft
    setSearchParams({}, { replace: true });

    const handleImpersonate = async () => {
      setLoading(true);
      try {
        const res = await dispatch(ImpersonateUser(payload));

        if (res?.success) {
          // Full page reload to reset Redux store and all active application states
          window.location.href = "/";
        } else {
          console.error("Failed to impersonate user:", res?.message || "Invalid credentials");
          setLoading(false);
          navigate("/signin", { replace: true });
        }
      } catch (error) {
        console.error("Error during impersonation:", error);
        setLoading(false);
        navigate("/signin", { replace: true });
      }
    };

    handleImpersonate();
  }, [hasImpersonateParams, key, impersonator, impersonated, dispatch, navigate, setSearchParams]);

  // If currently processing an impersonation handoff, block the outlet to prevent UI leaks
  if (loading || hasImpersonateParams) {
    return <LoadingSpinner />;
  }

  return <Outlet />;
};

export default CheckImpersonate;
